export default __webpack_public_path__ + "static/media/santa-maria.6f87226a.jpg";